import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface StatementsTaxBreakdownDialogData {
	title: string;
	rows: { name?: string; amount?: number }[];
}

@Component({
	selector: 'app-statements-tax-breakdown-dialog',
	templateUrl: './statements-tax-breakdown-dialog.component.html',
	standalone: false,
})
export class StatementsTaxBreakdownDialogComponent {
	constructor(@Inject(MAT_DIALOG_DATA) public data: StatementsTaxBreakdownDialogData) {}

	get total(): number {
		return (this.data?.rows ?? []).reduce((s, t) => s + (t?.amount ?? 0), 0);
	}
}
